import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {fromPromise} from "rxjs/internal/observable/innerFrom";

@Injectable()
export class TranslationFileReaderService {

  readFile(file: File): Observable<string> {
    return fromPromise(new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = error => reject(error);
      reader.readAsText(file);
    }));
  }
}
